import api from './api'
import moment from 'moment'
import siteVersions from '../site-versions/api'

export default {
  namespaced: true,
  state: {
    routeKey: 'rapperId',
    routes: {
      index: 'rappers.index',
      create: 'rappers.create',
      edit: 'rappers.edit'
    },
    table: [
      { code: 'site_versions', type: 'function', get: data => data.map(item => item.name).join(', ') },
      { code: 'publish', type: 'boolean' },
      { code: 'code', type: 'string', sort: true },
      { code: 'nickname', type: 'string', sort: true },
      { code: 'image', type: 'image', width: 100 },
      { code: 'created_at', type: 'datetime', sort: true },
      { code: 'updated_at', type: 'datetime', sort: true }
    ],
    form: [
      { code: 'site_versions', type: 'multiselect', options: [], size: 6, validation: { required: true } },
      { code: 'publish', type: 'boolean' },
      { code: 'weight', type: 'array', keys: [] },
      { code: 'code', type: 'text', validation: { required: true } },
      { code: 'name', type: 'text', validation: { required: true } },
      { code: 'nickname', type: 'text' },
      { code: 'image', type: 'image' },
      { code: 'alt_image', type: 'image' },
      {
        code: 'socials',
        type: 'array',
        keys: [
          { code: 'instagram', label: 'Instagram' },
          { code: 'vk', label: 'VK' },
          { code: 'facebook', label: 'Facebook' }
        ]
      },
      { code: 'birthdate', type: 'date' },
      { code: 'birthplace', type: 'text' },
      { code: 'style', type: 'text' },
      { code: 'description', type: 'textarea' }
    ],
    item: {},
    items: [],
    meta: {},
    page: 1,
    sort: 'id'
  },
  mutations: {
    SET_ITEMS (state, data) {
      state.items = data.data || null
      state.meta = data.meta || null
    },
    SET_ITEM (state, data) {
      state.item = {
        id: data.id || null,
        locales: data.locales || [],
        site_versions: data.site_versions?.map(item => item.id) || [],
        publish: data.publish === true ? 1 : null,
        weight: data.weight || null,
        code: data.code || null,
        name: data.name || null,
        nickname: data.nickname || null,
        image_old: data.image || null,
        image: null,
        image_delete: null,
        alt_image_old: data.alt_image || null,
        alt_image: null,
        alt_image_delete: null,
        socials: {
          instagram: data.socials?.instagram || null,
          vk: data.socials?.vk || null,
          facebook: data.socials?.facebook || null
        },
        birthdate: data.birthdate ? moment(data.birthdate).format('DD.MM.YYYY') : null,
        birthplace: data.birthplace || null,
        style: data.style || null,
        description: data.description || null
      }
    },
    SET_SELECT_OPTIONS (state, { code, options }) {
      state.form.find(item => item.code === code).options = options
    },
    SET_FIELD_KEYS (state, { code, keys }) {
      state.form.find(item => item.code === code).keys = keys
    },
    SET_SORT (state, field) {
      state.sort = state.sort === field ? `-${field}` : field
    },
    SET_PAGE (state, page) {
      state.page = page
    }
  },
  actions: {
    async fetchItems ({ commit, state }) {
      const { data } = await api.index({
        'sort': state.sort,
        'page[number]': state.page
      })

      commit('SET_ITEMS', data)
    },
    clearItems ({ commit }) {
      commit('SET_ITEMS', {})
    },
    async fetchItem ({ commit }, { route }) {
      const { data: { data } } = await api.show(route.params.rapperId)

      commit('SET_ITEM', data)
    },
    async fetchSiteVersions ({ commit }) {
      const { data: { data } } = await siteVersions.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'site_versions', options })

      const keys = data.map(item => ({
        code: item.id,
        label: item.name
      }))

      commit('SET_FIELD_KEYS', { code: 'weight', keys })
    },
    clearItem ({ commit }) {
      commit('SET_ITEM', {})
    },
    async createItem ({ commit }, { form }) {
      const { data: { data } } = await api.store(form)

      commit('SET_ITEM', data)
    },
    async updateItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.update(route.params.rapperId, form)

      commit('SET_ITEM', data)
    },
    async deleteItem ({ commit }, { id }) {
      await api.destroy(id)
    }
  }
}
